import { render, staticRenderFns } from "./RegisterOTP.vue?vue&type=template&id=6fd499a8&scoped=true&"
import script from "./RegisterOTP.vue?vue&type=script&lang=ts&"
export * from "./RegisterOTP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd499a8",
  null
  
)

export default component.exports